import { CommonModule } from '@angular/common';
import { Component, OnInit, computed, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BehaviorSubject,
  Observable,
  filter,
  map,
  of,
  throwIfEmpty,
} from 'rxjs';
import { MyBidsOffersService } from 'src/app/services/my-bids-offers.service';
import { UserState } from 'src/app/store/user/user.reducer';
import { LoadingSpinnerComponent } from '../../custom/loading-spinner/loading-spinner.component';
import { Lot } from '../../bids-and-offers/lots.model';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { LotsService } from 'src/app/services/lots.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Negotiation } from '../../negotiations/negotiations.model';
import { MatIconModule } from '@angular/material/icon';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHandshake } from '@fortawesome/free-regular-svg-icons';
import { MatDividerModule } from '@angular/material/divider';
import { PriceTypePipe } from 'src/app/pipes/price-type.pipe';
import { selectUser } from 'src/app/store/user/user.selectors';

@Component({
  selector: 'app-my-bids-offers',
  imports: [
    CommonModule,
    LoadingSpinnerComponent,
    RouterModule,
    MatCardModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
    FontAwesomeModule,
    PriceTypePipe,
  ],
  templateUrl: './my-bids-offers.component.html',
  styleUrl: './my-bids-offers.component.css',
})
export class MyBidsOffersComponent implements OnInit {
  isLoading = true;
  userID = signal<string>(null);
  lots$: BehaviorSubject<Lot[]> = new BehaviorSubject<Lot[]>([]);
  filteredLots$: BehaviorSubject<Lot[]> = new BehaviorSubject<Lot[]>([]);
  negotiations = signal<Negotiation[]>(null);
  faHandShake = faHandshake;

  constructor(
    private myBidsOffersService: MyBidsOffersService,
    private store: Store<{ user: UserState }>,
    private lotsService: LotsService
  ) {
    this.store
      .select(selectUser)
      .pipe(map((user) => this.userID.set(user._id)))
      .subscribe();
  }

  ngOnInit(): void {
    this.myBidsOffersService
      .watch({ userID: this.userID() })
      .valueChanges.pipe(
        map((res) => {
          this.isLoading = false;
          // console.log('res', res);
          this.lots$.next(res.data.lots);
          this.filteredLots$.next(res.data.lots);
          this.negotiations.set(res.data.negotiations);
        })
      )
      .subscribe();
  }

  //hasNegotiation is a computed signal that returns a function that checks if lot_id exists once in the negotiations array
  hasNegotiation = computed(() => {
    return (lotId: string) =>
      this.negotiations().some((n) => n.lot_id === lotId);
  });

  searchList(e) {
    const searchValue = e.target.value.toLowerCase();
    this.lots$
      .pipe(
        map((lots) => {
          const filtered = lots.filter((lot) => {
            const shipBegin = new Date(lot.ship_begin);
            const shipEnd = new Date(lot.ship_end);
            // Adjust the conditions based on your negotiation model and search requirements
            return (
              (this.lotsService.getPriceText(lot.price) + '')
                .toLowerCase()
                .includes(searchValue) ||
              lot.commodity.toLowerCase().includes(searchValue) ||
              lot.destination.toLowerCase().includes(searchValue) ||
              lot.grade.toLowerCase().includes(searchValue) ||
              shipBegin.toISOString().includes(searchValue) ||
              shipEnd.toISOString().includes(searchValue) ||
              lot.delivery_type.toLowerCase().includes(searchValue)
            );
          });
          this.filteredLots$.next(filtered);
          return filtered;
        })
      )
      .subscribe();
  }
}
